module.exports = __webpack_public_path__ + "static/media/visa-electron.4a9fa27d.svg";